<template>
  <div class="son">
            <div class="inner">
                <inputdata :rules='count[index].rules'></inputdata>
            </div>
            <div class="icondelete">
                <span class="el-icon-remove-outline" @click="removechild(index)" v-if="count.length>=1"></span>
            </div>
    </div>
</template>

<script>
import inputdata from '@/components/children/input.vue'

export default {
    components:{
        inputdata
    },
    name:'childrenf',
    props:['count','index','id'],
    mounted(){
    },
    methods:{
        removechild(index){
            this.$emit('delete',index)
        }
    }
}
</script>

<style scoped>
.son{
    position: relative;
    /* background-color: #bbb; */
}
.inner{
        width: 100%;
    }
    .icondelete{
        color: brown;
        position: absolute;
        right: 0;
        top: 20px;
        /* margin-top: 10px; */
        width: 50px;
    cursor: pointer;
    }
    .icondelete:active{
        color: red;
    }
    .el-icon-circle-plus-outline{
    color: greenyellow;
    cursor: pointer;
}
.el-icon-circle-plus-outline:active{
    color: blue;
}
</style>


// WEBPACK FOOTER //
// src/components/children/childrenf.vue